import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/ochrana-osobnich-udaju" as const,
	[Locale.en]: "/data-protection" as const,
} satisfies LocalizedString;

export function getGdprPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
